import React from 'react';
import { HeroSection } from './components/HeroSection';
import { BenefitsSection } from './components/BenefitsSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FinalCTA } from './components/FinalCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <main className="min-h-screen bg-white font-sans text-gray-900 antialiased selection:bg-green-100 selection:text-green-900" data-id="element-0">
      {/* No Navigation - Distraction Free */}

      <div className="w-full" data-id="element-1">
        <HeroSection data-id="element-2" />
        <BenefitsSection data-id="element-3" />
        <SocialProofSection data-id="element-4" />
        <FinalCTA data-id="element-5" />
      </div>

      <PurchasePopup data-id="element-6" />

      {/* Footer Simple */}
      <footer className="py-8 text-center text-gray-400 text-xs border-t border-gray-100" data-id="element-7">
        <p data-id="element-8">
          © {new Date().getFullYear()} MegaPack Anti-Pantallas. Todos los
          derechos reservados.
        </p>
        <p className="mt-2" data-id="element-9">
          Este sitio no es parte de Facebook o Facebook Inc.
        </p>
      </footer>
    </main>;
}